import { render, staticRenderFns } from "./GiveRecognitionModal.vue?vue&type=template&id=192c91be&scoped=true&"
import script from "./GiveRecognitionModal.vue?vue&type=script&lang=js&"
export * from "./GiveRecognitionModal.vue?vue&type=script&lang=js&"
import style0 from "./GiveRecognitionModal.vue?vue&type=style&index=0&id=192c91be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192c91be",
  null
  
)

export default component.exports